var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('Sidebar',{ref:"sidebar"}),_c('div',{staticClass:"page-wrapper h-screen"},[_c('navbar'),_c('div',{staticClass:"container-xl"}),_c('div',{staticClass:"page-body"},[_vm._t("default")],2),_c('Footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }